/* ════ TAG EDITOR (task + idea modals) ═════════════════════ */
// Edits state.taskTags / state.ideaTags as chip lists with a type-to-add input.
import { state } from './state.js';
import { $ } from './dom.js';

function render(listId, key) {
  const arr = state[key], el = $(listId); el.innerHTML = '';
  arr.forEach((t, i) => {
    const chip = document.createElement('span'); chip.className = 'tag-chip';
    chip.textContent = t;
    const x = document.createElement('button'); x.className = 'tag-x'; x.type = 'button'; x.innerHTML = '&times;';
    x.onclick = () => { arr.splice(i, 1); render(listId, key); };
    chip.appendChild(x); el.appendChild(chip);
  });
}

export function refreshTaskTags() { render('f-tags-list', 'taskTags'); }
export function refreshIdeaTags() { render('idea-tags-list', 'ideaTags'); }

function bind(inputId, listId, key) {
  const inp = $(inputId);
  const add = () => {
    inp.value.split(',').map(s => s.trim()).filter(Boolean).forEach(v => {
      if (!state[key].includes(v)) state[key].push(v);
    });
    inp.value = ''; render(listId, key);
  };
  inp.addEventListener('keydown', e => {
    if (e.key === 'Enter' || e.key === ',') { e.preventDefault(); add(); }
    else if (e.key === 'Backspace' && !inp.value && state[key].length) { state[key].pop(); render(listId, key); }
  });
  inp.addEventListener('blur', add);
}

export function initTagInputs() {
  bind('f-tags-input', 'f-tags-list', 'taskTags');
  bind('idea-tags-input', 'idea-tags-list', 'ideaTags');
}
